import { gql } from "@apollo/client";

export const ME = gql`
	query Me {
		me {
			id
			name
			email
			role
			emloyee1c
			userToWarehouses {
				id
				warehouse {
					id
					name
					city
				}
			}
		}
	}
`;
